import React from "react";
import CheckboxFilter from "./Checkbox.filter";
import SelectFilter from "./Select.filter";

class Filters extends React.Component {
  render() {
    if (this.props.checkbox) return <CheckboxFilter {...this.props}></CheckboxFilter>;
    return <SelectFilter {...this.props}></SelectFilter>;
  }
}

export default Filters;



// WEBPACK FOOTER //
// src/components/filter/Filters.js